import {PayoffReasonEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import {LF} from '@/i18n/LF';

export function payoffReasonNameFilter(reason: PayoffReasonEnum) {
  switch(reason) {
    case PayoffReasonEnum.VehicleRent: return i18n.t(LF.VehicleRent) as string;
    case PayoffReasonEnum.Bonus: return i18n.t(LF.Bonus) as string;
    case PayoffReasonEnum.Charge: return i18n.t(LF.Charge) as string;
    case PayoffReasonEnum.ResidentCard: return i18n.t(LF.ResidentCard) as string;
    case PayoffReasonEnum.Bag: return i18n.t(LF.Bag) as string;
    case PayoffReasonEnum.ContractualPenalties: return i18n.t(LF.ContractualPenalties) as string;
    case PayoffReasonEnum.Bailiff: return i18n.t(LF.Bailiff) as string;
    case PayoffReasonEnum.Sii: return i18n.t(LF.SII) as string;
    case PayoffReasonEnum.VehicleDamage: return i18n.t(LF.VehicleOrEquipmentDamage) as string;
    case PayoffReasonEnum.WorkingOnFleetCar: return i18n.t(LF.WorkingOnFleetCar) as string;
    case PayoffReasonEnum.WorkLegalizationProcess: return i18n.t(LF.WorkLegalizationProcess) as string;
    case PayoffReasonEnum.ResourceConsumption: return i18n.t(LF.ResourceConsumption) as string;
    case PayoffReasonEnum.ForFuturePayment: return i18n.t(LF.ForFuturePayment) as string;
    case PayoffReasonEnum.DayOff: return i18n.t(LF.DayOff) as string;
    case PayoffReasonEnum.ForFuturePaymentForTransport: return i18n.t(LF.ForFuturePaymentForTransport) as string;
    case PayoffReasonEnum.RentalOnlyCharge: return 'Opłata za sam wynajem';
    case PayoffReasonEnum.Cashback: return i18n.t(LF.Cashback) as string;
    case PayoffReasonEnum.Referral: return i18n.t(LF.ReferralReward) as string;
  }
}
